import React, { useRef } from "react";
import { motion, useScroll, useTransform, useReducedMotion } from "framer-motion";
import { useIsMobile } from "@/lib/useIsMobile";

// Wraps a section as a floating 3D panel that tilts into place as it enters
// the viewport — the connective tissue of the immersive scroll experience.
// On mobile / reduced-motion the panel renders statically (guaranteed visible
// on iOS Safari, which handles scroll-linked 3D transforms unreliably).
export const SectionShell = ({ children, className = "", testId }) => {
  const ref = useRef(null);
  const reduce = useReducedMotion();
  const isMobile = useIsMobile();
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start end", "start 0.28"],
  });
  const rotateX = useTransform(scrollYProgress, [0, 1], [10, 0]);
  const y = useTransform(scrollYProgress, [0, 1], [90, 0]);
  const scale = useTransform(scrollYProgress, [0, 1], [0.94, 1]);
  const opacity = useTransform(scrollYProgress, [0, 0.5], [0.55, 1]);

  const animated = !reduce && !isMobile;

  return (
    <div ref={ref} className="[perspective:1600px] px-2 sm:px-4 lg:px-6" data-testid={testId}>
      <motion.div
        style={animated ? { rotateX, y, scale, opacity, transformOrigin: "center top" } : { opacity: 1, rotateX: 0, y: 0, scale: 1 }}
        className={`transform-gpu will-change-transform rounded-[2rem] border border-white/10 bg-[rgba(13,14,17,0.93)] shadow-[var(--shadow-elev-2)] overflow-hidden ${className}`}
      >
        {children}
      </motion.div>
    </div>
  );
};
